import { EntityType } from '../../../@types/entityTypes';
import BoxLabelDispatchReportMutation from '../../../graphql/mutations/sales/BoxLabelDispatchReportMutation.graphql';
import BoxLabelSingleDispatchReportMutation from '../../../graphql/mutations/sales/BoxLabelSingleDispatchReportMutation.graphql';
import { ReportType } from '../../schema/p4types';
import * as printFunctions from '../../../actions/sales/BoxLabelPrintFunction';

const workspaceUrl = '/Sales/DispatchInstructions/Workspace/';

const BoxLabelInstructions: EntityType = {
  type: 'BoxLabelInstruction',
  workspaceUrl: workspaceUrl,
  generate: BoxLabelSingleDispatchReportMutation,
  generateRange: BoxLabelDispatchReportMutation,
  printFunctions: printFunctions,
  title: 'Dispatch Box Labels',
  formTitle: 'Print Box Labels',
  configuration: {
    title: 'Box Labels',
    reportType: ReportType.DispatchBoxLabel,
  },
  mergeFields: [],
};

export default BoxLabelInstructions;
